import React from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';

// Components
import { Loading } from "@gpstrackit/gtc-react-controls";

const EventInfo = (props) => {
    const { eventName } = props
    const { messages } = useIntl();

    // Redux States
    const loading = useSelector((state) => state.driverPerformanceEventsTabEventInfoRedux.loading);

    return (
        <div style={{ minHeight: 45, width: 249 }}>
            {
                loading ? <div><Loading full /></div > :
                <div>
                <div style={{ display: 'flex', alignItems: 'flex-start', minHeight: 25 }}>
                    <strong style={{ marginRight: 5 }}>{messages['driver_performance_events_info_name']}:</strong><p style={{ wordBreak: 'break-word', overflowWrap: 'break-word', margin: 0, flex: 1, minWidth: 0 }}>{messages[`driver_performance_${eventName.replace(/\s+/g, "")}`] || eventName}</p>
                </div>
                <div style={{ display: 'flex', alignItems: 'flex-start', minHeight: 20 }}>
                    <strong style={{ marginRight: 5 }}>{messages['driver_performance_events_info_category']}:</strong><p style={{ wordBreak: 'break-word', overflowWrap: 'break-word', margin: 0, flex: 1, minWidth: 0 }}>{messages['driver_performance_events_info_risk']}</p>
                </div>
            </div>
            }
        </div>
    )
}

export default EventInfo;